import { bffApi } from "../../../../../services/bff/bffApi";
import { BaseService } from "../../../../../global/classes";

export default class TransactionHistoryAnticipationService extends BaseService {

 public async getTransactionAnticipation(historyAnticipationId: number) {
    return bffApi.get(
      `/api/gcb/v1/anticipation/transaction-anticipation-history/${historyAnticipationId}`
    );
  }

 public async downloadTransactionHistoryAnticipationXls(historyAnticipationId: number) {
  return bffApi.get(
    `/api/gcb/v1/anticipation/transaction-Anticipation-History-xls/${historyAnticipationId}`,
    {
      responseType: "blob",
    }
  );
}
}
